import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { ERROR, INFO, SUCCESS, WARNING } from './actions';
import CashInFailed from './messages/CashInFailed';
import Congratulations from './messages/Congratulations';
import CongratulationsOnline from './messages/CongratulationsOnline';
import TransferFailed from './messages/TransferFailed';
import WithdrawFailed from './messages/WithdrawFailed';
import WrongNumber from './messages/WrongNumber';
import { getMessage } from './selectors';

const customRenderers = {
  WrongNumber,
  Congratulations,
  CashInFailed,
  WithdrawFailed,
  TransferFailed,
  CongratulationsOnline
};

export const FormMessage = ({ message, className }) => {
  if (!message) {
    return (<div />);
  }

  const { content = '', messageType = INFO, raw = true, fieldErrors } = message;
  const messageClassNames = classnames({
    'form-message': true,
    'form-message--error': messageType === ERROR,
    'form-message--success': messageType === SUCCESS,
    'form-message--warning': messageType === WARNING,
    'form-message--info': messageType === INFO
  }, className);

  let contentToRender;

  if (raw) {
    contentToRender = content;
  } else {
    const Component = customRenderers[content];

    if (!Component) {
      throw new Error(`Component '${content}' is not found.`);
    }

    contentToRender = <Component details={fieldErrors} />;
  }

  return (
    <div className={messageClassNames}>
      {contentToRender}
    </div>
  );
};

FormMessage.propTypes = {
  message: PropTypes.object,
  className: PropTypes.string
};

const mapStateToProps = (initialState, initialProps) => (state) => ({
  message: getMessage(state, initialProps)
});

export default connect(mapStateToProps)(FormMessage);
